import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.25 9.67a.76.76 0 0 1-.75.75h-9a.75.75 0 1 1 0-1.5h9a.75.75 0 0 1 .75.75ZM7.5 12.25h-4a.75.75 0 1 0 0 1.5h4a.75.75 0 1 0 0-1.5Zm-4-5.17h9a.75.75 0 1 0 0-1.5h-9a.75.75 0 0 0 0 1.5Zm0-3.33h9a.75.75 0 1 0 0-1.5h-9a.75.75 0 0 0 0 1.5Z';

const draw24px =
  'M18.563 14.088a.95.95 0 0 1-.938.937H6.375a.938.938 0 0 1 0-1.875h11.25a.938.938 0 0 1 .938.938Zm-7.188 3.225h-5a.938.938 0 0 0 0 1.875h5a.938.938 0 0 0 0-1.875Zm-5-6.463h11.25a.938.938 0 0 0 0-1.875H6.375a.937.937 0 1 0 0 1.875Zm0-4.162h11.25a.937.937 0 0 0 0-1.875H6.375a.937.937 0 1 0 0 1.875Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const NoteIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'note'),
) as IconWithRender;

NoteIcon.displayName = 'NoteIcon';
NoteIcon.propTypes = Icon.propTypes;
NoteIcon.renderIcon = (props) => <NoteIcon {...props} />;
export default NoteIcon;
